module.exports = __webpack_public_path__ + "static/media/lb.1e4ff784.svg";